import { render, staticRenderFns } from "./stdbill.vue?vue&type=template&id=879ad338&scoped=true&"
import script from "./stdbill.vue?vue&type=script&lang=js&"
export * from "./stdbill.vue?vue&type=script&lang=js&"
import style0 from "./stdbill.vue?vue&type=style&index=0&id=879ad338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879ad338",
  null
  
)

export default component.exports